import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Instagram, Facebook, Youtube, Music, Mic, Mail, Phone, MapPin, Send } from 'lucide-react';
import { motion } from 'framer-motion';
export function Contact() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-294">
      <Header data-id="element-295" />

      <main className="pt-32 pb-24" data-id="element-296">
        <section className="max-w-7xl mx-auto px-6 mb-24" data-id="element-297">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-298">
            {/* Contact Info & Social */}
            <div className="lg:col-span-5" data-id="element-299">
              <span className="section-overline" data-id="element-300">Get in Touch</span>
              <h1 className="text-[#4A0E0E] mb-8" data-id="element-301">
                Let's Create Something Extraordinary
              </h1>
              <p className="text-[#2C2C2C]/60 mb-12" data-id="element-302">
                Whether you're planning an intimate home tasting or a
                large-scale corporate gala, our team is ready to curate a
                bespoke experience tailored to your vision.
              </p>

              <div className="space-y-8 mb-16" data-id="element-303">
                <div className="flex items-center gap-6 group" data-id="element-304">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-305">
                    <Mail size={20} data-id="element-306" />
                  </div>
                  <div data-id="element-307">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-308">
                      Email Us
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-309">
                      hello@corkdorx.com
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-6 group" data-id="element-310">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-311">
                    <Phone size={20} data-id="element-312" />
                  </div>
                  <div data-id="element-313">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-314">
                      Call Us
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-315">(951) 555-0123</p>
                  </div>
                </div>
                <div className="flex items-center gap-6 group" data-id="element-316">
                  <div className="w-12 h-12 rounded-full bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-317">
                    <MapPin size={20} data-id="element-318" />
                  </div>
                  <div data-id="element-319">
                    <p className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 mb-1" data-id="element-320">
                      Location
                    </p>
                    <p className="font-serif text-[#4A0E0E]" data-id="element-321">
                      Temecula, CA & Beyond
                    </p>
                  </div>
                </div>
              </div>

              {/* Social Media Section */}
              <div className="pt-12 border-t border-[#E6D5B8]/30" data-id="element-322">
                <h4 className="text-xs font-bold uppercase tracking-[0.2em] mb-8" data-id="element-323">
                  Connect With Us
                </h4>
                <div className="grid grid-cols-3 gap-6" data-id="element-324">
                  <a href="#" className="flex flex-col items-center gap-3 group" data-id="element-325">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-326">
                      <Instagram size={24} data-id="element-327" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 group-hover:text-[#4A0E0E]" data-id="element-328">
                      Instagram
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group" data-id="element-329">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E] group-hover:bg-[#4A0E0E] group-hover:text-white transition-all" data-id="element-330">
                      <Facebook size={24} data-id="element-331" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40 group-hover:text-[#4A0E0E]" data-id="element-332">
                      Facebook
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-333">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-334">
                      <Music size={24} data-id="element-335" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-336">
                      TikTok
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-337">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-338">
                      <Youtube size={24} data-id="element-339" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-340">
                      YouTube
                    </span>
                  </a>
                  <a href="#" className="flex flex-col items-center gap-3 group opacity-40 hover:opacity-100 transition-opacity" data-id="element-341">
                    <div className="w-14 h-14 rounded-2xl bg-[#FDFCF0] flex items-center justify-center text-[#4A0E0E]" data-id="element-342">
                      <Mic size={24} data-id="element-343" />
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-[#2C2C2C]/40" data-id="element-344">
                      Podcast
                    </span>
                  </a>
                </div>
              </div>
            </div>

            {/* Inquiry Form */}
            <div className="lg:col-span-7" data-id="element-345">
              <div className="bg-[#FDFCF0] p-8 md:p-16 rounded-[3rem] border border-[#E6D5B8]/50 shadow-sm" data-id="element-346">
                <h2 className="text-3xl font-serif text-[#4A0E0E] mb-12" data-id="element-347">
                  Inquiry Form
                </h2>
                <form className="space-y-8" data-id="element-348">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-349">
                    <div className="space-y-2" data-id="element-350">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-351">
                        Full Name
                      </label>
                      <input type="text" placeholder="John Doe" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-352" />
                    </div>
                    <div className="space-y-2" data-id="element-353">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-354">
                        Email Address
                      </label>
                      <input type="email" placeholder="john@example.com" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-355" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-356">
                    <div className="space-y-2" data-id="element-357">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-358">
                        Phone Number
                      </label>
                      <input type="tel" placeholder="(555) 000-0000" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-359" />
                    </div>
                    <div className="space-y-2" data-id="element-360">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-361">
                        Desired Date
                      </label>
                      <input type="date" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-362" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-363">
                    <div className="space-y-2" data-id="element-364">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-365">
                        Event Type
                      </label>
                      <select className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-366">
                        <option data-id="element-367">Private Tasting</option>
                        <option data-id="element-368">Corporate Event</option>
                        <option data-id="element-369">Wine Cocktail Class</option>
                        <option data-id="element-370">Culinary Pairing</option>
                        <option data-id="element-371">Other</option>
                      </select>
                    </div>
                    <div className="space-y-2" data-id="element-372">
                      <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-373">
                        Guest Count
                      </label>
                      <input type="number" placeholder="e.g. 15" className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-374" />
                    </div>
                  </div>

                  {/* Qualification Questions */}
                  <div className="pt-8 border-t border-[#E6D5B8]/30 space-y-8" data-id="element-375">
                    <h3 className="text-xl font-serif text-[#4A0E0E]" data-id="element-376">
                      Event Qualification
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-377">
                      <div className="space-y-4" data-id="element-378">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-379">
                          Event Category
                        </p>
                        <div className="flex gap-4" data-id="element-380">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-381">
                            <input type="radio" name="category" className="accent-[#4A0E0E]" data-id="element-382" />
                            <span className="text-sm" data-id="element-383">Private</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-384">
                            <input type="radio" name="category" className="accent-[#4A0E0E]" data-id="element-385" />
                            <span className="text-sm" data-id="element-386">Corporate</span>
                          </label>
                        </div>
                      </div>
                      <div className="space-y-4" data-id="element-387">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-388">
                          Venue Status
                        </p>
                        <div className="flex gap-4" data-id="element-389">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-390">
                            <input type="radio" name="venue" className="accent-[#4A0E0E]" data-id="element-391" />
                            <span className="text-sm" data-id="element-392">Secured</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-393">
                            <input type="radio" name="venue" className="accent-[#4A0E0E]" data-id="element-394" />
                            <span className="text-sm" data-id="element-395">Needed</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-396">
                      <div className="space-y-4" data-id="element-397">
                        <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-398">
                          Setting
                        </p>
                        <div className="flex gap-4" data-id="element-399">
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-400">
                            <input type="radio" name="setting" className="accent-[#4A0E0E]" data-id="element-401" />
                            <span className="text-sm" data-id="element-402">Indoor</span>
                          </label>
                          <label className="flex items-center gap-2 cursor-pointer" data-id="element-403">
                            <input type="radio" name="setting" className="accent-[#4A0E0E]" data-id="element-404" />
                            <span className="text-sm" data-id="element-405">Outdoor</span>
                          </label>
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-406">
                        <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-407">
                          Estimated Budget
                        </label>
                        <select className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none" data-id="element-408">
                          <option data-id="element-409">Under $2,500</option>
                          <option data-id="element-410">$2,500 - $5,000</option>
                          <option data-id="element-411">$5,000 - $10,000</option>
                          <option data-id="element-412">$10,000+</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-4" data-id="element-413">
                      <p className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-414">
                        Wine Pairing Needed?
                      </p>
                      <div className="flex gap-4" data-id="element-415">
                        <label className="flex items-center gap-2 cursor-pointer" data-id="element-416">
                          <input type="radio" name="pairing" className="accent-[#4A0E0E]" data-id="element-417" />
                          <span className="text-sm" data-id="element-418">Yes</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer" data-id="element-419">
                          <input type="radio" name="pairing" className="accent-[#4A0E0E]" data-id="element-420" />
                          <span className="text-sm" data-id="element-421">No</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-422">
                    <label className="text-[10px] uppercase tracking-widest font-bold text-[#4A0E0E]" data-id="element-423">
                      Additional Details
                    </label>
                    <textarea rows={4} placeholder="Tell us more about your vision..." className="w-full bg-white border border-[#E6D5B8] rounded-xl px-6 py-4 text-sm focus:ring-1 focus:ring-[#4A0E0E] outline-none resize-none" data-id="element-424"></textarea>
                  </div>

                  <button className="w-full bg-[#4A0E0E] text-white py-6 rounded-full font-bold uppercase tracking-[0.2em] text-sm hover:bg-[#D4AF37] transition-all duration-500 shadow-xl flex items-center justify-center gap-3" data-id="element-425">
                    Submit Inquiry <Send size={18} data-id="element-426" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-427" />
    </motion.div>;
}